export const travelManagementSelector = state => state.travelManagementReducer;
